import { Observable } from 'rxjs';
import { IPrivacyPolicy } from 'src/app/models/parameters/IPrivacyPolicy';

export abstract class IPrivacyPolicyService {
    abstract getPrivacyPolicies(): Observable<IPrivacyPolicy[]>;
    abstract getPrivacyPoliciesByLanguage(): Observable<IPrivacyPolicy>;
}
